<template>
  <b-table :data="targetBuilds" ref="table" :mobile-cards="false"
           hoverable striped bordered v-bind="$attrs" v-on="$listeners" sticky-header height="80vh"
           class="target-builds-table">
    <template #empty>
      <b><slot name="empty-message">No results found</slot></b>
    </template>

      <b-table-column v-slot="props" field="started_at" label="Time" width="40">
        {{ props.row.started_at }}
      </b-table-column>

      <b-table-column v-slot="props" field="target" label="Target" width="100">
          <CiServiceIcon :ci-service="props.row.ci_service"/>
          <BuildTriggerTypeIcon :type="props.row.build_type_id"/>
        {{ props.row.target }}
      </b-table-column>

      <b-table-column v-slot="props" field="branch" label="Branch" width="50">
        {{ props.row.branch }}
      </b-table-column>

      <b-table-column v-slot="props" field="commit_id" label="Commit ID" width="50">
          {{ props.row.commit_id }}
      </b-table-column>

      <b-table-column v-slot="props" field="test_results" label="Tests summary" width="100">
        <router-link :to="generateResultsLink(props.row)">
          <test-summary-result :test-result="props.row"/>
        </router-link>
      </b-table-column>
  </b-table>
</template>

<script>
    import TestSummaryResult from "./TestSummaryResult";
    import CiServiceIcon from "@/components/CiServiceIcon";
    import BuildTriggerTypeIcon from "@/components/BuildTriggerTypeIcon";
    export default {
        name: "TargetBuildTable",
        props: {
            targetBuilds: Array,
            linkGenerator: Function,
        },
        components: {
            TestSummaryResult,
            CiServiceIcon,
            BuildTriggerTypeIcon,
        },
        methods: {
            generateResultsLink(targetBuild) {
                if (this.linkGenerator == null) return '#';
                return this.linkGenerator(targetBuild);
            }
        },
    }
</script>

<style scoped>
</style>